import assigned_locations from "./assigned_locations";
import create from "./create";
import datasheets from "./datasheets";
import del from "./delete";
import forum from "./forum";
import get from "./get";
import images from "./images";
import invites from "./invites";
import joinExtremophile from "./joinExtremophile";
import list from "./list";
import locations from "./locations";
import manageMembers from "./manageMembers";
import map from "./map";
import members from "./members";
import photo_observations from "./photo_observations";
import project_downloads from "./project_downloads";
import resources from "./resources";
import results from "./results";
import show from "./show";
import update from "./update";

export default {
  namespaced: true,
  modules: {
    assigned_locations,
    create,
    datasheets,
    del,
    forum,
    get,
    images,
    invites,
    joinExtremophile,
    list,
    locations,
    manageMembers,
    map,
    members,
    photo_observations,
    project_downloads,
    resources,
    results,
    show,
    update,
  }
};
